import React from 'react'
import { ApplicationForms } from '@shared/components/forms/application'
import PageAnimation from '@shared/components/page-animation'
import { Actioners } from '@shared/components/sections/actioners'
import { Feedback } from '@shared/components/sections/feedback'
import { ServicesInvestors } from '@shared/components/sections/services-investors'
import { Smi } from '@shared/components/sections/smi'
import { AboutYoutube } from 'screens/about/sections/about-youtube'
import { Journal } from 'screens/about/sections/journal'
import { SectionBanks } from 'screens/feedback/sections/Banks'
import { SectionCredit } from 'screens/feedback/sections/Credit'
import { SectionFirstDeposit } from 'screens/feedback/sections/FirstDeposit'
import { SectionMain } from 'screens/feedback/sections/Main'

import { feedbackInvestData, feedbackInvestorsData } from './data'

const View = () => (
	<PageAnimation>
		<SectionMain />
		<SectionBanks />
		<Feedback
			title='Credit.Club Кредиты'
			subtitle={`Занимаемся кредитованием под залог квартир с 2012 года. Работаем по всей России\nна полном доверии клиентов`}
		/>
		<div className='sw-app' data-app='5537753160e9372cacf6a6032873dbc4'></div>
		<SectionCredit />
		<ApplicationForms.CrossNew
			processBarText='Вероятность одобрения кредита'
			formTitle='Заявка на кредит'
			loanPercent={9.5}
		/>
		<Feedback
			title='Credit.Club Инвестиции'
			data={feedbackInvestData}
			subtitle='Наш продукт «Сбережения» помог инвесторам заработать десятки миллионов рублей'
		/>
		<Feedback
			cols={2}
			title={'Среди наших клиентов есть инвесторы\nс большим опытом'}
			data={feedbackInvestorsData}
			subtitle='Читайте их интервью и мнения о «Сбережениях» в нашем журнале «Процент»'
		/>
		<SectionFirstDeposit />
		<Smi />
		<Journal />
		<AboutYoutube />
	</PageAnimation>
)

export default View
